import { NgModule, ModuleWithProviders } from '@angular/core';
import { CommonModule } from '@angular/common';

import { CiscoUiModule } from './cisco-ui/cisco-ui.module';
import { ContentModule } from './content/content.module';
import { DialogsModule } from './dialogs/dialogs.module';
import { GravityModule } from './gravity/gravity.module';
import { NotificationsModule } from './notifications/notifications.module';
import { PresentationsModule } from './presentations/presentations.module';
import { UtilsModule } from './utils/utils.module';

@NgModule({
  imports: [
    CommonModule,

    CiscoUiModule,
    ContentModule.forRoot(),
    DialogsModule,
    GravityModule,
    NotificationsModule,
    PresentationsModule.forRoot(),
    UtilsModule
  ],
  exports: [
    CiscoUiModule,
    ContentModule,
    DialogsModule,
    GravityModule,
    NotificationsModule,
    PresentationsModule,
    UtilsModule
  ]
})
export class UiCoreModule {}
